// useHqCompany.js — 초기설정 카드의 회사가 "이 사이트 본사"인가 (2026-10-27 'PINE' 정리 5번, 하드코딩 금지)
//   예전엔 회사 코드가 'PINE' 인지로 갈랐다 → 미팅링크 본사(LINK) 카드가 외부회사 주소(/api/admin/ext/LINK/…)로 가서 막혔다.
//   본사 = 장부의 이 사이트 주인 회사(서버 /api/me hqCompanyCode → CompanyScopeContext). 파인그룹은 PINE 이라 그대로.
//   scopeMismatch: 본사 주소(/api/admin/…)는 운영자의 작업 대상 헤더(X-Scope-Company)를 따른다. 작업 대상이 손님 회사면
//   본사 카드로 등록해도 그 손님 회사로 들어가므로, 그때는 카드를 막고 작업 대상을 바꾸라고 안내한다.
import { useCompanyScope } from '../adminlayout/CompanyScopeContext';
import { readScopeCompany } from '../../../api/scopeCompany';

export function useHqCompany(companyCode) {
  const scope = useCompanyScope();
  const hq = String(scope?.hqCompanyCode || '').toUpperCase();
  const ready = Boolean(scope?.hqReady);
  const code = String(companyCode || '').toUpperCase();
  const isHq = ready && Boolean(hq) && code === hq;
  const header = String(readScopeCompany() || '').toUpperCase();
  const scopeMismatch = isHq && Boolean(header) && header !== hq;
  return { ready, isHq, scopeMismatch };
}
